import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Page} from '../../core/pagination/page';
import {PageRequest} from '../../core/pagination/page-request';
import {SortOrder} from '../../core/sort/sort-order';
import {Therapeut} from '../therapeut';

@Component({
    selector: 'zah-therapeuten',
    templateUrl: './therapeuten.component.html',
    styleUrls: ['./therapeuten.component.scss'],
    standalone: false
})
export class TherapeutenComponent implements OnInit {

  @Input()
  initialPageRequest: PageRequest<Therapeut>;
  @Input()
  therapeutenPage: Page<Therapeut>;
  @Output()
  therapeutClicked: EventEmitter<Therapeut> = new EventEmitter<Therapeut>();
  @Output()
  deleteClicked: EventEmitter<Therapeut> = new EventEmitter<Therapeut>();
  @Output()
  addClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  pageChange: EventEmitter<PageRequest<Therapeut>> = new EventEmitter<PageRequest<Therapeut>>();

  private currentPageRequest: PageRequest<Therapeut>;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  onTherapeutClick(therapeut: Therapeut): void {
    this.therapeutClicked.emit(therapeut);
  }

  onDeleteClick(therapeut: Therapeut): void {
    this.deleteClicked.emit(therapeut);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Therapeut>(sortOrder, this.currentPageRequest.getPageSize());
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageSizeChange(pageSize: number): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Therapeut>(this.currentPageRequest.getSortOrder(), pageSize);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageChange(pageRequest: PageRequest<Therapeut>): void {
    this.currentPageRequest = pageRequest;
    this.pageChange.emit(pageRequest);
  }
}
